import './App.css';
import {NextUIProvider} from "@nextui-org/react"
import NavigationBar from './components/NavigationBar';
import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
  return (
    <NextUIProvider>
      <NavigationBar />
    </NextUIProvider>
  );
}

export default App;
